import { ComboboxItem, Group, InputWrapper, MantineStyleProps, SegmentedControl, Select, SelectProps, Stack, Text, ThemeIcon, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconCheck, IconCircleFilled } from "@tabler/icons-react";
import { useGetPrioritiesQuery } from "../../api/priority.api";
import classes from './PriorityInput.module.css';
import { ReactNode } from "react";
import React from "react";

interface PriorityInputProps extends MantineStyleProps{
	label?: string;
	value: string;
	hidden?: boolean;
	error?: ReactNode;
	onChange: (value: string) => void;
}

export const PriorityInput = ({ label, value, hidden = false, error, onChange, ...props }: PriorityInputProps) => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
	const { data: priorities } = useGetPrioritiesQuery();

	const items = priorities?.map(p => ({ 
		label: <Stack gap={0} align="center">
					<ThemeIcon variant="transparent" color={p.Colour}><IconCircleFilled size={16} /></ThemeIcon>
					<Text inherit visibleFrom="sm" maw={100} style={{ textWrap: 'wrap' }}>{p.Title}</Text>
					<Text inherit hiddenFrom="sm" maw={100} style={{ textWrap: 'wrap' }}>{p.ShortTitle}</Text>
				</Stack>,
		value: p.PriorityId 
	})) ?? [];
	
	const listItems: ComboboxItem[] = priorities?.map(p => ({ 
		label: p.Title,
		value: p.PriorityId 
	})) ?? [];

	const iconProps = {
		stroke: 3,
		opacity: 0.5,
		size: 16,
	};

	const renderSelectOption: SelectProps['renderOption'] = ({ option, checked }) => (
		<Group flex="1" gap={4}>
			<ThemeIcon variant="transparent" color={priorities?.find(p => p.PriorityId === option.value)?.Colour}><IconCircleFilled size={16} /></ThemeIcon>
			{option.label}
			{checked && <IconCheck style={{ marginInlineStart: 'auto' }} {...iconProps} />}
		</Group>
	);

	if (hidden) return null;
	
	return <>
		<InputWrapper label={label} error={error}>
			{priorities && priorities?.length <= 4 &&
				<SegmentedControl
					value={value}
					onChange={onChange}
					data={items}
					fullWidth
					className={classes.priorityInput}
					mb="xs"
					{...props}
				/>
			}

			{priorities && priorities?.length > 4 &&
				<Select
					data={listItems}
					renderOption={renderSelectOption}
					leftSection={<ThemeIcon variant="transparent" color={priorities?.find(p => p.PriorityId === value)?.Colour}><IconCircleFilled size={16} /></ThemeIcon>}
					value={value}
					onChange={(value) => onChange(value ?? '')}
					hidden={!isMobile}
					className={classes.priorityInputMobile}
					{...props}
				/>
			}

		</InputWrapper>
	</>;
}